import type { CommandProperties } from '@atlassian/rovo-content-bridge-api/command';

import { log } from '../utils/aifc-logging';

import { CommandHandler } from './command-handler';
import type { PassThroughCommandProps } from './command-handler';

export class StreamErroredCommandHandler extends CommandHandler<CommandProperties, void> {
	constructor(
		props: PassThroughCommandProps,
		private onError: () => void,
	) {
		super(props);
	}

	execute(): void {
		log('handle rovo-stream-errored-command');
		try {
			this.onError();
		} catch {
			// TODO: EDITOR-123 - report this error
		}
	}
}
